import { render, staticRenderFns } from "./Predelava.vue?vue&type=template&id=5b788192&"
import script from "./Predelava.vue?vue&type=script&lang=js&"
export * from "./Predelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports